/*
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-02 22:13:18
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-01-19 11:21:45
 */
const order = [
    {
        path: '/orderlist/consultList',
        name: 'orderlist',
        component: () => import('../views/order/consultList.vue'),
    },
  {
    path: '/orderlist/search',
    name: 'ordersearch',
    component: () => import('../views/order/ordersSearch.vue'),
  },
  {
    path: '/order/detail',
    name: 'orderdetail',
    component: () => import('../views/order/detail.vue'),
  },
  {
    path: '/orderlist/all',
    name: 'orderlistAll',
    component: () => import('../views/order/all-list.vue'),
    meta:{
      keepAlive:true
    }
  },
  {
    path: '/orderlist/aggList',
    name: 'aggList',
    component: () => import('../views/order/aggList.vue'),
  },
  {
    path: '/orderlist/aggList/search',
    name: 'aggListSearch',
    component: () => import('../views/order/aggSearch.vue'),
  },
    {
        path: '/orderlist/pharmacyList',
        name: 'pharmacyList',
        component: () => import('../views/order/pharmacyList.vue'),
    },
    // 老版本迁移--我的订单
    {
      path: '/orderlist',
      name: 'orderlist',
      component: () => import('../views/order/pharmacyList.vue'),
    },
    {
        path: '/orderlist/pharmacyDetail/:id',
        name: 'pharmacyDetail',
        component: () => import('../views/order/pharmacyDetail.vue'),
    },
    {
        path: '/orderlist/pharmacyOrderDetail/:id/:type?',
        name: 'pharmacyOrderDetail',
        component: () => import('../views/order/pharmacyOrderDetail.vue'),
    },
    {
        path: '/orderlist/pharmacyList/search',
        name: 'pharmacyList',
        component: () => import('../views/order/pharmacySearch.vue'),
    },
  {
    path: '/order/detail/agg/:id/:type?',
    name: 'aggOrderDetail',
    component: () => import('../views/order/aggDetail.vue'),
  },
  {
    path: '/logistics/list/:id',
    name: 'aggOrderList',
    component: () => import('../views/logistics/list.vue'),
  },
  {
    path: '/logistics/detail/:id',
    name: 'logisticsDetail',
    component: () => import('../views/logistics/detail.vue'),
  },
  {
    path: '/logistics/jd/list/:id',
    name: 'logisticsJdList',
    component: () => import('../views/logistics/jd-list.vue'),
  },
  {
    path: '/aggOrder/address/change',
    name: 'aggOrdeAddressChange',
    component: () => import('../views/order/changeAddress.vue'),
    meta:{
      keepAlive:true
    }
  },
  {
    path: '/drugs/saveOrder/:type/:id',
    name: 'aggOrderDetail',
    component: () => import('../views/order/saveOrder.vue'),
    meta:{
      keepAlive:true
    }
  },
  {
    path: '/order/transportUpdate/:id',
    name: 'transportUpdate',
    component: () => import('../views/order/transportUpdate'),
  },
  {
    path: '/order/invoiceInfo/:id',
    name: 'invoiceInfo',
    component: () => import('../views/order/invoiceInfo'),
  },
  {
    path: '/order/invoiceFileList',
    name: 'invoiceFileList',
    component: () => import('../views/order/invoiceFileList'),
  },
  {
    path: '/order/applyApparatus/:id',
    name: 'applyApparatus',
    component: () => import('../views/order/applyApparatus'),
  },
  {
    path: '/order/invoice/detail/:type/:id',
    name: 'applyApparatus',
    component: () => import('../views/servicePackage/invoice-detail.vue'),
  },
]
export default order



// WEBPACK FOOTER //
// ./src/router/order.js